// extracted by mini-css-extract-plugin
export default {"card":"Card_card__zQfcO","header":"Card_header__LgAhk","title":"Card_title__fjt9r","action":"Card_action__t6GHH","content":"Card_content__ASKh8","loading":"Card_loading__jYUzQ"};